module.exports = __webpack_public_path__ + "img/8c188bdfe094594cd1f1c08fb82f2b68.png";